module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';

	require('./_shortcuts-bootstrapper.styl');

	require('services/exodentity')(fox);
	
	require('widget/periodicalUpdater')(fox);
	require('widget/favico')(fox);
	require('widget/copyright')(fox);
	require('widget/content/browser')(fox);
	require('widget/content/photosets')(fox);
	require('widget/content/liveshows')(fox);
	require('widget/content/scenes')(fox);
	require('widget/content/favorites')(fox);
	require('widget/content/flashplayer')(fox);
	require('widget/content/sceneViewer')(fox);
	
	require('widget/social/favorite')(fox);
	require('widget/social/activity')(fox);
	require('widget/social/comments')(fox);
	require('widget/social/comments/form')(fox);
	require('widget/social/rating')(fox);
	
	require('widget/jqtimer')(fox);
	require('widget/join/form')(fox);
	require('widget/user/login')(fox);
	require('widget/captcha')(fox);
	require('widget/pager/simple')(fox);
	require('widget/tips/form')(fox);

	require('../components/splash')(fox);
	require('../components/avs-yoti')(fox);

	require('jquery-ui/ui/core');
	require('jquery-ui/ui/widget');
	require('jquery-ui/ui/dialog');
	require('jquery-ui/ui/datepicker');

	require('script!jquery.mCustomScrollbar.min');
	require('script!imagesloaded/imagesloaded.pkgd');
	require('script!masonry/dist/masonry.pkgd');
	require('script!jquery-counter/src/jquery.counter.js');
	require('script!socket-io-client');

	require('script!slick-carousel/slick/slick');
	require('slick-carousel/slick/slick.css');

	require('script!swfobject');
	
	require('htmlplayer/css/acplayercolors.css');
	require('htmlplayer/widget/html5player2')(fox);

	require('script!notify.js');
	require('script!../script/mp.min.js');
	//images;
	require('../images/cbCpWhite.png');

	require('../components/strip-notification')(fox);
	
	require('../components/user-notifications-settings')(fox);
	require('../components/user-profile')(fox);
	require('../components/user-personal-data')(fox);


	require('../components/liveshow')(fox);

	require('../components/common')(fox);
	
	require('../components/push-notifications')(fox);
	require('../components/sesta-fosta')(fox);
	require('../components/expremiumuser')(fox);

	require('../components/cancellation')(fox);

	require('script!lazysizes/lazysizes');
	window.lazySizesConfig = window.lazySizesConfig || {};
	window.lazySizesConfig.loadMode = 1;
	window.lazySizesConfig.minSize = 30;

	// common widgets
	require('common-widgets/select')(fox);
	// GDPR popups
	require('GDPR-popups')(fox);
		// CCPA Form
	require('../components/ccpa')(fox);
	require('../../../common-components/CCPA/widget/page')(fox);
	require('../../../common-components/CCPA/widget/form')(fox);
	require('../../../common-components/CCPA/templates/mc/doc.a.tpl')(fox);
	require('../../../common-components/CCPA/templates/mc.a.tpl')(fox);

	require('../components/expremiumuser')(fox);

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/dependencies/dependencies.js
// module id = 453
// module chunks = 4